import formatMoney from '../../core/formatMoney';
import checkProductsExist from './check-products-exist';
import getProductID from './get-product-id';
import { waitForGtag } from '../../core/helpers.js';
// import { openSliderCart } from '../../sections/slider-cart';

const productTileMarkup = `
  <div class="cart-wishlist__item cart-wishlist-item" data-cart-wishlist-item data-cart-wishlist-item-id="{{id}}">
    <div class="cart-wishlist-item__top">
      <a href="{{du}}" onClick="gtag('event', 'friends_family', {'step': 'product-selected'});"><img loading="lazy" class="cart-wishlist-item__image" src="{{iu}}" alt="Wishlist item image" onError="this.closest('[data-cart-wishlist-item]').remove();" /></a>
    </div>

    <div class="cart-wishlist-item__bottom">
      <p class="cart-wishlist-item__title" data-cart-wishlist-item-title>{{dt}}</p>
      <p class="cart-wishlist-item__options" data-cart-wishlist-item-options>{{variants}}</p>
      <p class="cart-wishlist-item__price" data-cart-wishlist-item-price><span class="money">{{pr_formatted}}</span></p>
    </div>

    <a href="javascript: void(0);" data-product-id="{{empi}}" data-url="{{du}}" data-variant-id="{{epi}}" class="move-to-cart cart-wishlist-item__move-to-cart btn btn--secondary" data-move-to-cart>
      {{#isInCart}}Moved to bag{{/isInCart}}
      {{^isInCart}}Move to bag{{/isInCart}}
    </a>
  </div>
`;

const loadSharedWishlist = () => {
  return new Promise(async (resolve, reject) => {
    const url = new URL(window.location.href);
    const lid = url.searchParams.get('lid');
    const ff_name = url.searchParams.get('ff_name');

    const sharedWishlistItemEls = document.querySelectorAll('[data-shared-wishlist-item]');
    const referrerNameEls = document.querySelectorAll('[data-referrer-name]');

    if (!lid || lid.length === 0) {
      sharedWishlistItemEls.forEach(el => el.textContent = 'Cannot find the Wishlist');
      return;
    }

    if (ff_name && ff_name.length !== 0) {
      const nameText = `${decodeURIComponent(ff_name.replace(/\+/g, '%20'))}'S `;
      referrerNameEls.forEach(el => el.textContent = nameText);
    }

    const listConfig = { lid };
    
    // Define success callback
    const onSuccess = function(listDetails) {
      // Successfully fetched list details
      console.log('Successfully fetched List details', listDetails);
      resolve(listDetails);
    };
    
    // Define error callback
    const onError = function(error) {
      // Error is an xhrObject
      sharedWishlistItemEls.forEach(el => el.textContent = 'Cannot load the Wishlist, please try later.');
      console.log('Error while fetching List details', error);
    };
    
    // Call `fetchListDetails` with the above callbacks and listConfig
    window._swat.fetchListDetails(listConfig, onSuccess, onError);
  });
};

const buildSharedWishlistTiles = (wishlistProducts) => {
  const wishlistItemsContainer = document.getElementById('shared-wishlist-items');

  const sharedWishlistItems = document.querySelectorAll('[data-shared-wishlist-items]');
  sharedWishlistItems.forEach(el => el.innerHTML = '');

  let count_whishlist_item = 0;
  wishlistProducts.forEach((wishlistProduct) => {
    try {
      const wishlist_product_id = getProductID(wishlistProduct);
      wishlistProduct.id = wishlist_product_id;

      if (wishlist_product_id !== null) {
        wishlistProduct.isInCart = _swat.platform.isInDeviceCart(wishlistProduct.epi);

        if (window.Shopify.country === 'US') {
          wishlistProduct.pr_formatted = formatMoney(Number(wishlistProduct.pr) * 100, theme.moneyFormat);
        } else {
          wishlistProduct.pr_formatted = formatMoney(Math.ceil(Number(wishlistProduct.pr) * window.Shopify.currency.rate) * 100, theme.moneyFormat);
        }

        // Swym doesn't allow html tags
        wishlistProduct.pr_formatted = wishlistProduct.pr_formatted.replace("<span class='money'>", '').replace('</span>', '');

        // console.log('wishlistProduct', wishlistProduct.dt, wishlistProduct.vi);
        // console.log('wishlistProduct.variants', wishlistProduct.variants);

        wishlistProduct.du = wishlistProduct.du.replace(`https://${window.location.host}`, `https://${window.location.host}${window.Shopify.routes.root.slice(0, -1)}`);

        const renderedProductTile = SwymUtils.renderTemplateString(productTileMarkup, wishlistProduct);
        wishlistItemsContainer.insertAdjacentHTML('beforeend', renderedProductTile);

        // Cleanup variant and price once rendered
        let option_html = '';
        if (typeof wishlistProduct.variants === 'undefined') {
          if (typeof wishlistProduct.vi !== 'undefined') {
            const item_options = (wishlistProduct.vi.includes('/')) ? wishlistProduct.vi.split('/') : wishlistProduct.vi.split(' ');

            if (item_options.length === 1) {
              option_html += `<span class="cart-wishlist-item__misc">${wishlistProduct.vi}</span>`;
            } else if (item_options.length > 1) {
              // console.log(item_options)
              const size = item_options[item_options.length - 1];
              item_options.pop();
              const color = item_options.join(' ');

              option_html += `<span class="cart-wishlist-item__color">Color: ${color}</span>`;
              option_html += `<span class="cart-wishlist-item__size">Size: ${size}</span>`;
            }
          }
        } else {
          const item_options = (typeof wishlistProduct.variants === 'object') ? wishlistProduct.variants : JSON.parse(wishlistProduct.variants);
          const option_values = (Object.keys(item_options[0])[0].indexOf('/') === -1) ? Object.values(item_options[0])[0].split(' / ') : Object.keys(item_options[0])[0].split(' / ');
          option_values.forEach((option_value, i) => {
            if (i === 0) {
              if (option_values.length > 1) {
                option_html += `<span class="cart-wishlist-item__color">Color: ${option_value}</span>`;
              } else {
                option_html += `<span class="cart-wishlist-item__misc">${option_value}</span>`;
              }
            }
    
            if (i === 1) {
              option_html += `<span class="cart-wishlist-item__size">Size: ${option_value}</span>`;
            }
          });
        }

        // Set options HTML
        const optionsEl = document.querySelector(`[data-cart-wishlist-item-id="${wishlist_product_id}"] [data-cart-wishlist-item-options]`);
        if (optionsEl) optionsEl.innerHTML = option_html;

        // Set price HTML
        const priceEl = document.querySelector(`[data-cart-wishlist-item-id="${wishlist_product_id}"] [data-cart-wishlist-item-price]`);
        if (priceEl) {
          if (window.Shopify.country === 'US') {
            priceEl.innerHTML = formatMoney(Number(wishlistProduct.pr) * 100, theme.moneyFormat);
          } else {
            priceEl.innerHTML = formatMoney(Math.ceil(Number(wishlistProduct.pr) * window.Shopify.currency.rate) * 100, theme.moneyFormat);
          }
        }

        // Add new-row class every 4th item
        if (count_whishlist_item % 4 === 0) {
          const itemEl = document.querySelector(`[data-cart-wishlist-item-id="${wishlist_product_id}"]`);
          if (itemEl) itemEl.classList.add('new-row');
        }

        // Cleanup title
        let product_title = wishlistProduct.dt;
        if (product_title.indexOf(' - ') !== -1) {
          const product_title_parts = product_title.split(' - ');
          const last_title_part = product_title_parts[product_title_parts.length - 1];
          product_title = product_title.replace(` - ${last_title_part}`, '');
          const titleEl = document.querySelector(`[data-cart-wishlist-item-id="${wishlist_product_id}"] [data-cart-wishlist-item-title]`);
          if (titleEl) titleEl.innerHTML = product_title;
        }

        count_whishlist_item++;

        // User might have a product that doesn't exist in store in its wishlist, remove it if it's the case
        if (count_whishlist_item === wishlistProducts.length) {
          checkProductsExist(wishlistProducts);
        }

        // if (window.theme.isZonos && typeof zonos !== 'undefined') {
        //   zonos.displayCurrency();
        // }

        window.dispatchEvent(new Event('resize'));
      }
    } catch (error) {
      console.log('Wishlist error', error);
    }
  });
};

let swym_ready_checks = 0;
// https://developers.swym.it/docs/fetch-list-details
const initSharedWishlistPage = () => {
  return new Promise(async (resolve, reject) => {
    if (!$('#shared-wishlist').length) {
      return;
    }

    if (typeof window._swat === 'undefined' && swym_ready_checks < 5) {
      window.setTimeout(() => {
        swym_ready_checks++;
        initSharedWishlistPage();
      }, 1000);

      return;
    }

    const list = await loadSharedWishlist();
    if (typeof list.items === 'undefined' || list.items.size === 0) {
      $('[data-shared-wishlist-item]').html('This wishlist is empty.');
      return;
    }

    waitForGtag(() => {
      gtag('event', 'friends_family', {
        'step': 'list-viewed',
      });
    });

    buildSharedWishlistTiles(list.items);

    $(document).on('click', '[data-shared-wishlist-items] [data-move-to-cart]', (e) => {
      try {
        e.preventDefault();
        const item = e.target;
    
        const productId = item.getAttribute('data-product-id');
        const variantId = item.getAttribute('data-variant-id');
        let du = item.getAttribute('data-url');
        du = (du.substring(0, 4) === 'http') ? du : `${window.location.origin}${du}`;
        item.innerHTML = 'Adding to Bag...';
    
        window._swat.replayAddToCart({ empi: productId, du, }, variantId, () => {
            console.log('Successfully moved product to bag.');
            item.innerHTML = 'Moved to Bag';
            
            gtag('event', 'friends_family', {
              'step': 'added-to-cart',
            });

            window.setTimeout(() => {
              // openSliderCart();
              window.location.reload(false);
            }, 2000);
          }, (event) => {
            e.target.innerHTML = window.theme.strings.unavailable;
          },
        );
      } catch (e) {
        console.log(e);
      }
    });

    resolve(true);
  });
};

export {
  initSharedWishlistPage,
};
